const routes = [
  {
    path: '/stationDispatch',
    name: 'stationDispatch',
    component: () => import('./pages/Home'),
    redirect: '/stationDispatch/index',
    meta: {
      requireAuth: true
    },
    children: [
      {
        path: 'index',
        name: 'stationDispatchIndex',
        component: () => import('./pages/stationDispatch'),
        meta: {
          requireAuth: true,
          routerAlive: false
        }
      },
      {
        path: 'homeworkPic',
        name: 'homeworkPic',
        component: () => import('./pages/homeworkPic'),
        meta: {
          requireAuth: true,
          routerAlive: false
        }
      },
    ]
  }
]

export default routes